import React from "react";

const SecurityBox = () => {
  return (
    <form className="m-2 p-4">
      {/* <Grid container spacing={3}>
        <InputField
          label="Password"
          type="text"
          name="password"
          value={pwdRequest.password}
          handlechange={handleChange}
        />
        <InputField
          label={"New Password"}
          type="text"
          name="newPassword"
          value={pwdRequest.newPassword}
          handlechange={handleChange}
        />
      </Grid> */}
      {/* <div className="flex justify-end my-6">
      <button
          type="button"
          className="p-2 px-4 bg-black tracking-wide rounded-md hover:bg-transparent hover:text-black text-white border border-black"
          onClick={() => {}}
        >
          Update{" "}
        </button>
        <button
          type="button"
          className="p-2 mr-4 float-right rounded-md tracking-wide border border-black"
          onClick={() => {}}
        >
          Cancel{" "}
        </button>
       
      </div> */}
    </form>
  );
};

export default SecurityBox;
